export function Prices(props) {
  const { info } = props;

  return (
    <div className="w-full pt-6 mb-10">
      {info.totals.subtotal.original ? (
        <div className="flex items-center font-medium text-[#5F6E79] mb-5">
          <span className="mr-2">Subtotal</span>
          <hr className="flex-1 border-[#8B99A5] border-dotted border-b-[3px] h-[18px] border-0" />
          <span className="ml-2 whitespace-nowrap text-lg">
            {info.totals.subtotal.format}
          </span>
        </div>
      ) : (
        ""
      )}
      {info.totals.promotionDiscounts.length
        ? info.totals.promotionDiscounts.map((v, i) => (
            <div
              key={i}
              className="flex items-center font-medium text-[#5F6E79] mb-5"
            >
              <span className="mr-2">Discount ({v.promotionTitle})</span>
              <hr className="flex-1 border-[#8B99A5] border-dotted border-b-[3px] h-[18px] border-0" />
              <span className="ml-2 whitespace-nowrap text-lg">
                {v.sum.format}
              </span>
            </div>
          ))
        : ""}
      {info.totals.couponDiscounts && info.totals.couponDiscounts.coupon ? (
        <div className="flex items-center font-medium text-[#5F6E79] mb-5">
          <span className="mr-2">
            Coupon ({info.totals.couponDiscounts.coupon}{" "}
            {info.totals.couponDiscounts.percent}%)
          </span>
          <hr className="flex-1 border-[#8B99A5] border-dotted border-b-[3px] h-[18px] border-0" />
          <span className="ml-2 whitespace-nowrap text-lg">
            {info.totals.couponDiscounts.sum.format}
          </span>
        </div>
      ) : (
        ""
      )}

      {info.totals.tax.original ? (
        <div className="flex items-center font-medium text-[#5F6E79] mb-5">
          <span className="mr-2">Tax</span>
          <hr className="flex-1 border-[#8B99A5] border-dotted border-b-[3px] h-[18px] border-0 px-6" />
          <span className="ml-2 whitespace-nowrap text-lg">
            {info.totals.tax.format}
          </span>
        </div>
      ) : (
        ""
      )}
      {info.totals.shipping.original ? (
        <div className="flex items-center font-medium text-[#5F6E79] mb-8">
          <span className="mr-2">Shipping</span>
          <hr className="flex-1 border-[#8B99A5] border-dotted border-b-[3px] h-[18px] border-0 px-6" />
          <span className="ml-2 whitespace-nowrap text-lg">
            {info.totals.shipping.format}
          </span>
        </div>
      ) : (
        ""
      )}
      {info.totals.totalWithTaxes.original ? (
        <div className="flex items-center font-semibold text-[#5F6E79]">
          <span className="mr-2 text-lg">Total</span>
          <hr className="flex-1 border-[#8B99A5] border-dotted border-b-[3px] h-[18px] border-0 px-6" />
          <span className="ml-2 whitespace-nowrap text-[24px]">
            {info.totals.totalWithTaxes.format}
          </span>
        </div>
      ) : (
        ""
      )}

      {info.totals.totalInHouseFinancing ? (
        <div className="flex items-center font-medium text-[#5F6E79] mb-2 mt-1">
          <span className="mr-2">Financing Amount Due</span>
          <hr className="flex-1 border-[#8B99A5] border-dotted border-b-[3px] h-[18px] border-0 px-6" />
          <span className="ml-2 whitespace-nowrap text-lg">
            {info.totals.totalInHouseFinancing.format}
          </span>
        </div>
      ) : (
        ""
      )}
      {info.totals.payNowOnly ? (
        <div className="flex items-center font-semibold text-[#5F6E79]">
          <span className="mr-2 text-lg">Pay now only</span>
          <hr className="flex-1 border-[#8B99A5] border-dotted border-b-[3px] h-[18px] border-0 px-6" />
          <span className="ml-2 whitespace-nowrap text-[24px]">
            {info.totals.payNowOnly.format}
          </span>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
